<section class="manifiesto">
        <div class="image-container" data-aos="fade-right" data-aos-duration="800">
            <!-- <div class="image-overlay"></div> -->
            <img src="assets/images/home/manifiesto.webp" alt="Manifiesto Paredes & Asociados" >
        </div>

        <div class="text-content" data-aos="fade-left" data-aos-duration="800">
            <!-- <div class="decorative-line"></div> -->
            <!-- <app-badge text="Nuestro Manifiesto"></app-badge> -->
            <div class="quote-container">
                <div class="quote-mark opening">❝</div>
                <p class="quote-text">En Paredes & Asociados Constructores, entendemos que cada proyecto representa una inversión estratégica, una visión de crecimiento y una responsabilidad compartida.</p>
                <div class="quote-mark closing">❞</div>
            </div>
            <div class="signature">— Paredes & Asociados</div>
        </div>
</section>